import Icon from '../../components/icons/HubIcon'

export default {
  name: 'hubs',
  recordRepresentation: 'name',
  options: {
    defaultSort: { field: 'name', order: 'ASC' },
    referenceKey: 'hub_id',
    references: ['vehicles', 'bookings', 'incident-reports'],
    showResource: 'organisations',
  },
  icon: Icon,
}
